/**
 * Where to go after signing in (design 11, B9a). A deep link must survive the
 * sign-in, query string included. The code is entered on the sign-in page
 * itself (D-066), so the address rides in the router's state and never leaves
 * the page.
 *
 * Only a path on this site is ever returned to: anything else (another origin,
 * `//host`, the sign-in page itself) falls back to home, so a crafted link
 * cannot bounce someone off-site after they sign in.
 */

/** The address of a location, as far as a return needs it: path, query and hash. */
export function addressOf(location: { pathname: string; search: string; hash: string }): string {
  return `${location.pathname}${location.search}${location.hash}`;
}

/** A path on this site to return to, or `'/'`. */
export function safeReturnTo(value: unknown): string {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return '/';
  const path = value.split(/[?#]/, 1)[0];
  return path === '/signin' ? '/' : value;
}
